import React, { Component, Fragment } from "react";
import format from "date-fns/format";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import LoadingComponent from "../../../../app/layout/LoadingComponent";
import classes from "../Courier/index.module.css";
import ApproveTransfer from "./ApproveTransfer";

class index extends Component {
  state = {
    transferPanelOpen: false,
    selectedTransfer: null,
    loadingInitial: true,
  };

  handleTransferClick = (transfer) => {
    this.setState({
      transferPanelOpen: true,
      selectedTransfer: transfer,
    });
  };

  handleCloseClick = (e) => {
    if (e) e.preventDefault();
    this.setState({
      transferPanelOpen: false,
      selectedTransfer: null,
    });
  };

  formatCurrency = (amount) => {
    return new Intl.NumberFormat("en-BW", {
      style: "currency",
      currency: "BWP",
    }).format(amount);
  };

  render() {
    let { pendingTransfers, requesting, profile } = this.props;
    console.log(pendingTransfers, 'transfers')
    const loading = requesting[`pending_transfers`];
    let { transferPanelOpen, selectedTransfer } = this.state;

    let numberOfRecords = pendingTransfers && pendingTransfers.length;

    let attachedPaginateActiveClasses = [
      classes.paginate_button,
      classes.active,
    ];

    let attachedPaginateSimpleNumbersClasses = [
      classes.dataTables_paginate,
      classes.paging_simple_numbers,
    ];

    let attachedPaginateNextClasses = [classes.paginate_button, classes.next];

    if (loading)
      return (
        <Fragment>
          <LoadingComponent inverted={true} />
        </Fragment>
      );

    const transfers =
      pendingTransfers &&
      pendingTransfers.map((transfer, index) => {
        return (
          <tr
            className={classes.MerchantRow}
            key={index}
            onClick={() => this.handleTransferClick(transfer)}
          >
            <td>
              {transfer.initiatedAt
                ? format(transfer.initiatedAt.toDate(), "DD MMM YYYY HH:mm")
                : "N/A"}
            </td>
            <td>{transfer.fromAccount}</td>
            <td>{transfer.fromMerchantName}</td>
            <td>{transfer.toAccount}</td>
            <td>{transfer.toMerchantName}</td>
            <td>{this.formatCurrency(transfer.amount)}</td>
            <td>{transfer.initiatedBy}</td>
            <td>{transfer.status}</td>
          </tr>
        );
      });

    return (
      <Fragment>
        <div className={classes.MerchantTableWrapper}>
          {transfers && transfers.length === 0 ? (
            <div style={{ paddingBottom: "30px" }}>
              <h3>No pending transfers to approve.</h3>
            </div>
          ) : (
            <Fragment>
              <div className={classes.TableWrapper}>
                <table className={classes.MerchantTable}>
                  <thead>
                    <tr>
                      <th scope="col">Date Initiated</th>
                      <th scope="col">From Account</th>
                      <th scope="col">From Merchant</th>
                      <th scope="col">To Account</th>
                      <th scope="col">To Merchant</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Initiated By</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>{transfers}</tbody>
                </table>

                {transferPanelOpen && selectedTransfer ? (
                  <div className={classes.EnableMerchant}>
                    <div className={"card card-transparent"}>
                      <div
                        className={"card-header"}
                        style={{
                          padding: "1rem",
                          color: "#666",
                          fontSize: "1.4rem",
                          fontFamily: "Roboto",
                          fontWeight: "500",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          className={"card-title semi-bold"}
                          style={{
                            color: "#666",
                            fontSize: "1.4rem",
                            fontFamily: "Roboto",
                            fontWeight: "500",
                            textTransform: "none",
                          }}
                        >
                          Actions
                        </div>
                        <a
                          href="#"
                          onClick={this.handleCloseClick}
                          style={{ color: "#666" }}
                        >
                          <i className={"card-icon card-icon-close"} />
                        </a>
                      </div>
                      <div className={"card-body"}>
                        <ApproveTransfer
                          transfer={selectedTransfer}
                          closePanel={this.handleCloseClick}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className={classes.Row}>
                <div>
                  <div
                    className={attachedPaginateSimpleNumbersClasses.join(" ")}
                  >
                    <ul>
                      <li>
                        <a href="">
                          <i className={classes.pg_arrow_left} />
                        </a>
                      </li>
                      <li className={attachedPaginateActiveClasses.join(" ")}>
                        <a href="">1</a>
                      </li>
                      <li
                        className={attachedPaginateNextClasses.join(" ")}
                        id="tableWithExportOptions_next"
                      >
                        <a href="">
                          <i className={classes.pg_arrow_right} />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div
                    className={classes.dataTables_info}
                    id="tableWithExportOptions_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing <b>1 to {numberOfRecords}</b> of {numberOfRecords}{" "}
                    entries
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

let query = [
  {
    collection: "pending_transfers",
    where: ["status", "==", "Pending"],
  },
];

const mapStateToProps = (state) => ({
  pendingTransfers: state.firestore.ordered.pending_transfers,
  requesting: state.firestore.status.requesting,
  profile: state.firebase.profile,
});

const actions = {};

export default compose(
  connect(mapStateToProps, actions),
  firestoreConnect(query)
)(index);

